import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/rajant.png'
import _imports_1 from '@/assets/cambium.png'


const _hoisted_1 = { class: "titlePages" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Formato del archivo Rajant", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, "Formato del archivo Cambium", -1)

import { ref, onMounted, Ref } from 'vue';
import { read, utils }  from 'xlsx';
import axios            from 'axios';
import { useI18n }      from 'vue-i18n';

// CONSTANTS
import CONSTAPIS, { TIMEOUTTIME }        from '@/constants/apis';

// INTERFACES
import { GENERAL_EQUIPAMENT, IP_EQUIPAMENT } from '@/interfaces/SmartLink/Equips';
import { TOKEN } from '@/constants/labels';

interface NewEquipment {
  ip: string;
  tag: string;
  marca: string;
  rol: string;
  tipo: string;
  snmp_conf: number;
}


/**
 * Mostrar el Dialogo
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'AdminCSVView',
  setup(__props) {

const dialog = ref(false);
const typeIMG = ref('');


function showDialog(type:string){
  dialog.value = true
    if(type === 'rajant') typeIMG.value = 'rajant'
    if(type === 'cambium') typeIMG.value = 'cambium'

}

const { t }                                             = useI18n()
const rajant                                            = ref();
const cambium                                           = ref();
const fileItemRajant:Ref<GENERAL_EQUIPAMENT[]>          = ref([]);
const fileItemNameRajant:Ref<GENERAL_EQUIPAMENT[]>      = ref([]);
const fileItemCambium:Ref<GENERAL_EQUIPAMENT[]>         = ref([]);
const fileItemNameCambium:Ref<GENERAL_EQUIPAMENT[]>     = ref([]);
const fileItemInsertRajant:Ref<GENERAL_EQUIPAMENT[]>    = ref([]);
const fileItemInsertCambium:Ref<GENERAL_EQUIPAMENT[]>   = ref([]);
const snackbar                                          = ref(false);
const allEquipment:Ref<IP_EQUIPAMENT[]>                 = ref([]);

const errorRajant = ref(false);
const errorCambium = ref(false);
const handleFileRajantUpload = async (event: any) => {
  // 1. Gestión inicial del archivo
  const file = event.target.files?.[0];
  errorRajant.value = false;
  
  // Limpiamos todos los arrays de resultados para evitar duplicados
  fileItemRajant.value = [];
  fileItemNameRajant.value = [];
  fileItemInsertRajant.value = [];

  if (!file) return;

  try {
    const buffer = await file.arrayBuffer();
    const workbook = read(buffer, { type: 'array' });
    const worksheet = workbook.Sheets[workbook.SheetNames[0]];
    const jsonData = utils.sheet_to_json(worksheet, { header: 1 }) as any[][];

    // 2. Regex para validar formato IPv4
    const ipRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

    // 3. Optimización: Indexamos equipos actuales en Sets para búsqueda instantánea O(1)
    const existingIps = new Set(allEquipment.value.map((e: IP_EQUIPAMENT) => e.ip?.trim()));
    const existingNames = new Set(allEquipment.value.map((e: IP_EQUIPAMENT) => e.name?.trim()));

    jsonData.forEach((elem) => {
      const rawIp = elem[2]?.toString().trim() || '';
      
      // VALIDACIÓN: ¿Es una IP válida? (ya no importa si empieza por 10 o no)
      if (ipRegex.test(rawIp)) {
        const ipfinal = rawIp;
        const tag     = elem[1]?.toString().trim() || 'Sin Nombre';
        const tipo    = elem[6]?.toString().trim() || 'Desconocido';

        const isMatchIp   = existingIps.has(ipfinal);
        const isMatchName = existingNames.has(tag);

        // Lógica de clasificación
        if (isMatchIp) {
          // Caso A: La IP ya existe en la base de datos
          fileItemRajant.value.push({ ip: ipfinal, tag });
        } 
        else if (isMatchName) {
          // Caso B: El nombre existe pero con otra IP (Posible reasignación)
          fileItemNameRajant.value.push({ ip: ipfinal, tag, tipo });
        } 
        else {
          // Caso C: No existe ni IP ni Nombre (Equipo totalmente nuevo)
          fileItemInsertRajant.value.push({
            ip: ipfinal,
            tag: tag,
            marca: 'Rajant',
            rol: 'Cliente',
            tipo: tipo, 
            snmp_config: ''
          });
        }
      }
    });

    // 4. Feedback final
    if (fileItemRajant.value.length === 0 && 
        fileItemInsertRajant.value.length === 0 && 
        fileItemNameRajant.value.length === 0) {
      snackbar.value = true;
      errorRajant.value = true;
    }

  } catch (err) {
    console.error("Error al procesar el Excel:", err);
    errorRajant.value = true;
  }
};

const handleFileCambiumUpload = (event:any) => {

  errorCambium.value = false;
    
    if(event.target.files[0] !== undefined){
        fileItemCambium.value = [];

        const file = event.target.files[0];
        const reader = new FileReader();

        reader.onload = (e:any) => {

            const data      = new Uint8Array(e.target.result);
            const workbook  = read(data, { type: 'array' });
            const worksheet = workbook.Sheets[workbook.SheetNames[0]];
            const jsonData  = utils.sheet_to_json(worksheet, { header: 1 });

            jsonData.forEach((elem:any) => {

                if(elem[5]?.split('.')[0] === '10' && typeof elem[5] === 'string' && elem[5] !== ''){

                    let ipfinal     = elem[5];
                    let tag    = elem[4];
                    let tipo      = elem[7];
                    let isMatch     = false;
                    let isMatchName = false;

                    allEquipment.value.find(({ip,name}:IP_EQUIPAMENT)=>{
                        if(ip == ipfinal){
                            isMatch = true;
                        }
                        if(name == tag){
                            isMatchName = true;
                        }
                    })

                    if(isMatch){
                        let objFile = {
                            ip          :   ipfinal,
                            tag    :   tag,
                            tipo        :   tipo
                        }
                        fileItemCambium.value.push(objFile);
                    } else{
                        if(isMatchName && !isMatch){
                            let objFileName = {
                                ip              :   ipfinal,
                                tag        :   tag,
                                tipo:   tipo
                            }
                            fileItemNameCambium.value.push(objFileName);
                        } else{
                            let objFile:any = {
                                elemid      :   0,
                                ip          :   ipfinal,
                                tag    :   tag,
                                // modelo      :   modelo,
                                // serial      :   serial,
                                // marca       :   'Cambium',
                                // tipo        :   modelo.split(' ').slice(-1) == 'SM' ? 'PMP' : 'PMP-AP',
                                // subtipo     :   'Distribucion',
                                // observacion :   ' ',
                                // ubicacion   :   ' ',
                                // padre       :   0,
                                // gpsLat      :   ' ',
                                // gpsLong     :   ' ',
                                gpsAlt      :   ' '
                            }
                            fileItemInsertCambium.value.push(objFile);
                        }
                    }

                    let objFile = {
                        ip          :   ipfinal,
                        tag    :   tag,
                        modelo      :   elem[7],
                        serial      :   elem[8]
                    }
                    fileItemCambium.value.push(objFile);
                }
            })

            if(fileItemCambium.value.length === 0) {
                errorCambium.value = true;
                snackbar.value = true;
            }
        };
        reader.readAsArrayBuffer(file);
    }else{
        fileItemCambium.value = [];
    }
}

const clearData = (type:string) => {
    if(type === 'rajant') fileItemRajant.value = []
    if(type === 'cambium') fileItemCambium.value = []
}


const rajantEvent = async () => {
    await axios.put(CONSTAPIS.APIS.value.csv.editDataInven,fileItemRajant.value, { timeout: TIMEOUTTIME, headers: { "Authorization": `Bearer ${TOKEN}`} }).then((response)=>{
        if(response.status === 200){
            rajant.value                = [];
            fileItemRajant.value        = [];
        }                 
    })

    await axios.put(CONSTAPIS.APIS.value.csv.editDataByName,fileItemNameRajant.value, { timeout: TIMEOUTTIME, headers: { "Authorization": `Bearer ${TOKEN}`} }).then((response)=>{
        if(response.status === 200){
            rajant.value                = [];
            fileItemNameRajant.value    = [];
        }                 
    })

    await axios.post(CONSTAPIS.APIS.value.csv.insertDataInven,fileItemInsertRajant.value, { timeout: TIMEOUTTIME, headers: { "Authorization": `Bearer ${TOKEN}`} }).then((response)=>{
        if(response.status === 200){
            rajant.value                  = [];
            fileItemInsertRajant.value    = [];
        }                 
    })
}

const cambiumEvent = async () => {
    await axios.put(CONSTAPIS.APIS.value.csv.editDataInven,fileItemCambium.value, { timeout: TIMEOUTTIME, headers: { "Authorization": `Bearer ${TOKEN}`} }).then((response)=>{
        if(response.status === 200){
            cambium.value               = [];
            fileItemCambium.value       = [];
        } 
    })

    await axios.put(CONSTAPIS.APIS.value.csv.editDataByName,fileItemNameCambium.value, { timeout: TIMEOUTTIME, headers: { "Authorization": `Bearer ${TOKEN}`} }).then((response)=>{
        if(response.status === 200){
            cambium.value               = [];
            fileItemNameCambium.value   = [];
        } 
    })
    
    await axios.post(CONSTAPIS.APIS.value.csv.insertDataInven,fileItemInsertCambium.value, { timeout: TIMEOUTTIME, headers: { "Authorization": `Bearer ${TOKEN}`} }).then((response)=>{
        if(response.status === 200){
            cambium.value               = [];
            fileItemInsertCambium.value = [];
        }                 
    })
}

onMounted(async() => {
    await axios.get(CONSTAPIS.APIS.value.csv.getDataInven, { timeout: TIMEOUTTIME, headers: { "Authorization": `Bearer ${TOKEN}`} }).then((res)=>{
        allEquipment.value = res.data;
    })
})


return (_ctx: any,_cache: any) => {
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_card, {
      class: "defaultCard",
      color: "bgtopology",
      elevation: "0"
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(t)('adminPage.titleCSVview')), 1),
        _createVNode(_component_v_file_input, {
          modelValue: rajant.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((rajant).value = $event)),
          clearable: "",
          label: "MESH",
          density: "compact",
          variant: "outlined",
          onChange: handleFileRajantUpload,
          "onClick:clear": _cache[1] || (_cache[1] = ($event: any) => (clearData('rajant'))),
          class: "mt-5",
          "append-icon": "mdi-tooltip-question-outline",
          "onClick:append": _cache[2] || (_cache[2] = ($event: any) => (showDialog('rajant'))),
          error: errorRajant.value
        }, null, 8, ["modelValue", "error"]),
        _createVNode(_component_v_file_input, {
          modelValue: cambium.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((cambium).value = $event)),
          class: "mt-5",
          clearable: "",
          label: "PMP",
          density: "compact",
          variant: "outlined",
          onChange: handleFileCambiumUpload,
          "onClick:clear": _cache[4] || (_cache[4] = ($event: any) => (clearData('cambium'))),
          "append-icon": "mdi-tooltip-question-outline",
          "onClick:append": _cache[5] || (_cache[5] = ($event: any) => (showDialog('cambium'))),
          error: errorCambium.value
        }, null, 8, ["modelValue", "error"]),
        _createVNode(_component_v_row, { class: "mt-5 mb-3" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "6" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  disabled: fileItemRajant.value.length === 0,
                  block: "",
                  color: "bgCircular",
                  onClick: rajantEvent
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" MESH ")
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "6" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  disabled: fileItemCambium.value.length === 0,
                  block: "",
                  color: "bgCircular",
                  onClick: cambiumEvent
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" PMP ")
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_snackbar, {
          modelValue: snackbar.value,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((snackbar).value = $event))
        }, {
          actions: _withCtx(() => [
            _createVNode(_component_v_btn, {
              color: "pink",
              variant: "text",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (snackbar.value = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('adminPage.closeBtn')), 1)
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('adminPage.titleSnak')) + " ", 1)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: dialog.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((dialog).value = $event)),
      width: "50%"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            (typeIMG.value === 'rajant')
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 0,
                  cols: "12"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_sheet, {
                      color: "bgtopology rounded",
                      class: "pa-5"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2,
                        _createVNode(_component_v_img, { src: _imports_0 })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (typeIMG.value === 'cambium')
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 1,
                  cols: "12"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_sheet, {
                      color: "bgtopology rounded",
                      class: "pa-5"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_3,
                        _createVNode(_component_v_img, { src: _imports_1 })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})